/**
 * Convert `query` `[]` properties to array objects.
 */
export const generateParams = query =>
  Object.entries(query)
    .reduce((params, [key, value]) => {
      if (Array.isArray(value)) {
        value.forEach(v => params.append(key, v));
        return params;
      }
      params.append(key, value);
      return params;
    }, new URLSearchParams())
    .toString();

/**
 * Helps build URL & normalize it using standard URL() constructor
 * (https://developer.mozilla.org/en-US/docs/Web/API/URL/URL). Check out specs
 * for some examples.
 */
export default (baseUrl, options) => {
  let url = baseUrl;
  let path;
  let hash;
  let query;

  if (typeof options === "string") {
    path = options;
  } else if (options) {
    ({ path, hash, query } = options);
  }

  if (path) {
    if (!url.endsWith("/")) {
      url += "/";
    }
    if (path.startsWith("/")) {
      url += path.substr(1);
    } else {
      url += path;
    }
  }

  if (hash) {
    url += hash.startsWith("#") ? hash : `#${hash}`;
  }

  if (query) {
    const stringQuery =
      typeof query === "string" ? query : generateParams(query);
    url += stringQuery.startsWith("?") ? stringQuery : `?${stringQuery}`;
  }

  return new URL(url).toString();
};
